import React, { useEffect, useState, } from 'react'
import Swal from 'sweetalert2';
import { auth, db } from '../firebase';
import "../App.css";
import { collection, addDoc, Timestamp, query, orderBy, onSnapshot, getDoc, deleteDoc, doc, updateDoc } from 'firebase/firestore'
import Menu from '../panel/Menu';

export default function Subpaymode() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });
    const [userData, setUserData] = useState();
    const [loadincount, setloadincount] = useState(true);

    const [ownercredits, setownercredits] = useState([]);
    const [searchText, setsearchText] = useState("");

    const [ownername, setownername] = useState("");
    const [mobileno, setmobileno] = useState("");
    const [address, setaddress] = useState("");

    const [updocid, setupdocid] = useState("");
    const [upownername, setupownername] = useState("");
    const [upmobileno, setupmobileno] = useState("");
    const [upaddress, setupaddress] = useState("");

    useEffect(() => {
        if (searchText === '') {
            fetchData1()
        } else {
            fetchData2()
        }
    }, [searchText]);



    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fetchPropid()
        });
    });

    const fetchPropid = async () => {
        if (userData) {
            if (loadincount) {
                const docRef = doc(db, "users", userData.uid)
                const docSnap = await getDoc(docRef)
                if (docSnap.exists()) {
                    fetchData1();
                    setloadincount(false)
                }
            }
        }
    }

    const fetchData1 = async () => {
        try {
            const q = query(collection(db, 'ownercredits'), orderBy('createdAt', 'asc'))
            onSnapshot(q, (querySnapshot) => {
                setownercredits(querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data()
                })));
            });
        } catch (error) {
            Toast.fire({
                icon: "error",
                title: error.message
            });
        }
    }

    const fetchData2 = async () => {
        try {
            const filteredData = ownercredits.filter((item) =>
                item.data.ownername.toUpperCase().includes(searchText.toUpperCase())
            );
            setownercredits(filteredData);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }


    const handleSubmit = async () => {
        try {
            await addDoc(collection(db, "ownercredits"), {
                ownername: ownername,
                address: address,
                mobileno: mobileno,
                uid: userData.uid,
                createdAt: Timestamp.now(),
            });

            setownername("");
            setmobileno("");
            setaddress("");
            fetchData1();

            Toast.fire({
                icon: "success",
                title: 'Owner Credit Details Added Successfully!!'
            });
        } catch (err) {
            Toast.fire({
                icon: "error",
                title: 'Error in Room Service Adding!!'
            });

            console.log(err.message);
        }
    }

    const handleDelete = async (docid, imgLink) => {
        const taskDocRef = doc(db, 'ownercredits', docid)
        await deleteDoc(taskDocRef)
        Toast.fire({
            icon: "success",
            title: 'Owner Credit Details Deleted Successfully!!'
        });
        fetchData1();
    }

    const handleEdit = (id, ownername, address, mobileno) => {
        setupdocid(id);
        setupownername(ownername);
        setupaddress(address);
        setupmobileno(mobileno);
    }

    const handleUpdate = async () => {
        if (!upownername) {
            Toast.fire({
                icon: "error",
                title: 'Please Enter Required Fields!!'
            });
            return;
        }

        await updateDoc(doc(db, "ownercredits", updocid), {
            ownername: upownername,
            address: upaddress,
            mobileno: upmobileno,
        });
        Toast.fire({
            icon: "success",
            title: 'Owner Credit Details Updated Successfully!!'
        });

        fetchData1();
    }


    return (
        <div>
            <Menu />
            <div className="content-wrapper">
                <section className="content">
                    <div className="container-fluid">
                        <button className="btn btn-secondary " style={{ float: "right", textTransform: "uppercase" }} >|| Owner Credit Details  Mgmt ||</button>
                        <button className="btn btn-info btn-sm" data-toggle="modal" data-target="#insert-modal">Add Owner Credit Details</button><br /><br />
                        <div className="card card-primary card-outline ex1">
                            <div className=" p-1">
                                &nbsp;&nbsp;<input type="search" value={searchText} onChange={(e) => setsearchText(e.target.value)}
                                    className='form-control col-sm-4' placeholder='Type here......' />&nbsp;
                            </div>
                            <div className="card-body table-responsive p-0" >

                                <table className="table table-bordered table-hover table-striped table-head-fixed">
                                    <thead>
                                        <tr>
                                            <th>Sr No</th>
                                            <th> Owner Name</th>
                                            <th>Mobile No</th>
                                            <th>Address</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            ownercredits.map((item, num = 1) =>
                                                <tr key={num + 1}>
                                                    <td width="80">{num + 1}</td>
                                                    <td>{item.data.ownername}</td>
                                                    <td>{item.data.address}</td>
                                                    <td>{item.data.mobileno}</td>
                                                    <td>
                                                        <a onClick={() => handleEdit(item.id, item.data.ownername, item.data.address, item.data.mobileno)} href='#0' data-toggle="modal" data-target="#text-modal1" className="btn btn-sm btn-success" > <i className="fa fa-edit"></i></a>&nbsp;
                                                        <a onClick={() => { if (window.confirm('Are u sure?')) { handleDelete(item.id, item.data.imageurl) }; }} className="btn btn-sm btn-danger" href='#0' > <i className="fa fa-trash"></i></a>&nbsp;
                                                    </td>
                                                </tr>
                                            )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {/* ============================================= modal start ================================================= */}

            <div className="modal fade" id="insert-modal">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Add Owner Credit Details</h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span></button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-sm-6">
                                    <label>  Guest Name </label>
                                    <input type="text" value={ownername} onChange={(e) => setownername(e.target.value)} className="form-control" />
                                </div>
                                <div className="col-sm-6">
                                    <label>  Mobile No </label>
                                    <input type="text" value={address} onChange={(e) => setaddress(e.target.value)} className="form-control" />
                                </div>
                                <div className="col-sm-6">
                                    <label>  Address </label>
                                    <input type="text" value={mobileno} onChange={(e) => setmobileno(e.target.value)} className="form-control" />
                                </div>
                            </div><br />
                        </div>
                        <div className="modal-footer justify-content-between">
                            <button type="button" onClick={() => handleSubmit()} className="btn btn-primary" data-dismiss="modal">Save </button>
                            <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>


            <div className="modal fade" id="text-modal1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Edit Owner Credit Details</h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span></button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-sm-6">
                                    <label>  Guest Name </label>
                                    <input type="text" value={upownername} onChange={(e) => setupownername(e.target.value)} className="form-control" />
                                </div>
                                <div className="col-sm-6 ">
                                    <label>Mobile No</label>
                                    <input type="text" value={upaddress} onChange={(e) => setupaddress(e.target.value)} className="form-control" />
                                </div>
                                <div className="col-sm-6 ">
                                    <label>Address</label>
                                    <input type="text" value={upmobileno} onChange={(e) => setupmobileno(e.target.value)} className="form-control" />
                                </div>
                            </div><br />
                        </div>
                        <div className="modal-footer justify-content-between">
                            <button type="button" onClick={() => handleUpdate()} className="btn btn-primary" data-dismiss="modal">Update </button>
                            <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}
